import { useRef, useState } from 'react';

/**
 * Pointer-based drag that snaps back on release (jQuery UI `revert: true`).
 * Works for mouse and touch. `onDrop` gets the release point; the parent decides
 * whether it landed on a target.
 */
export default function Draggable({ className = '', style, disabled, onStart, onDrop, children, ...rest }) {
  const [offset, setOffset] = useState(null);
  const origin = useRef(null);

  const down = (e) => {
    if (disabled) return;
    e.currentTarget.setPointerCapture(e.pointerId);
    origin.current = { x: e.clientX, y: e.clientY };
    setOffset({ x: 0, y: 0 });
    onStart?.();
  };
  const move = (e) => {
    if (!origin.current) return;
    setOffset({ x: e.clientX - origin.current.x, y: e.clientY - origin.current.y });
  };
  const up = (e) => {
    if (!origin.current) return;
    origin.current = null;
    setOffset(null);
    onDrop?.({ x: e.clientX, y: e.clientY });
  };

  return (
    <div
      {...rest}
      className={`manor-draggable ${offset ? 'dragging' : ''} ${className}`}
      style={{ ...style, transform: offset ? `translate(${offset.x}px, ${offset.y}px)` : undefined }}
      onPointerDown={down}
      onPointerMove={move}
      onPointerUp={up}
      onPointerCancel={up}
    >
      {children}
    </div>
  );
}

/** Is the point inside the rect, allowing `pad` px of slack (fingers are less precise than a mouse). */
export const inside = (rect, pt, pad = 0) =>
  pt.x >= rect.left - pad && pt.x <= rect.right + pad && pt.y >= rect.top - pad && pt.y <= rect.bottom + pad;
